import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'gatsby'
import humanize from 'humanize-string'

const Breadcrumbs = ({ url }) => {
	const urls = url.split('/').filter(url => url.length > 0)
	let linkUrl = ''
	const urlElements = urls.map((url, index) => {
		linkUrl += `/${url}`
		if (index === urls.length - 1) {
			return (
				<li key={`${url}-${index}`} className="uk-width-auto">
					<span className="uk-text-break">{humanize(url)}</span>
				</li>
			)
		}

		return (
			<li key={`${url}-${index}`} className="uk-width-auto">
				<Link className="uk-text-break" to={linkUrl}>
					{humanize(url)}
				</Link>
			</li>
		)
	})

	return (
		<ul className="uk-breadcrumb uk-margin">
			<li>
				<Link to="/">Início</Link>
			</li>
			{urlElements.map(element => element)}
		</ul>
	)
}

Breadcrumbs.propTypes = {
	url: PropTypes.string.isRequired,
}

export default Breadcrumbs
